module.exports = __webpack_public_path__ + "img/add-bank.2a0d5928.png";